import loginView from "@/components/login/loginView.vue";
import homeView from "@/components/home/homeView.vue";
import BaiduMapView from "@/components/map/BaiduMapView.vue";
import mapView from "@/components/draw/mapView.vue";
import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: homeView,
    meta: { authRequired: true },
    children: [
      {
        path: "/mapManage",
        name: "mapManage",
        component: () => import("@/components/manage/mapManage.vue"),
      },
      {
        path: "/branchManage",
        name: "branchManage",
        component: () => import("@/components/branch/branchView.vue"),
      },
      {
        path: "/draw",
        name: "draw",
        component: mapView,
        meta: { authRequired: true },
      },
      {
        path: "/map",
        name: "map",
        component: BaiduMapView,
      },
    ],
  },

  {
    path: "/login",
    name: "login",
    component: loginView,
  },
];

const router = createRouter({
  base: "/",
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.authRequired) {
    //存在token正常跳转
    if (localStorage.getItem("postal-token")) {
      next();
    } else {
      next({ path: "/login", query: { redirect: to.fullPath } });
    }
  } else {
    next();
  }
});

export default router;
